import theme from '../../theme/theme';

const {
  colors: { subtitle, stars_rated, stars_unrated },
} = theme;

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '4.425em',
    padding: 0,
    paddingLeft: '1.625em',
    paddingRight: '1.5em',
  },

  title: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '220px',
    fontSize: '1.250em',
    fontWeight: 'normal',
    letterSpacing: '-0.031em',
    color: subtitle,
  },

  icon: {
    width: '2em',
    height: '2em',
  },

  stars: {
    paddingRight: '1em',
    alignItems: 'center',
    display: 'flex',
  },

  star__rated: {
    color: stars_rated,
    fontSize: '1.4em',
    padding: 0,
  },

  star__unrated: {
    color: stars_unrated,
    fontSize: '1.4em',
    padding: 0,
  },
};

export default styles;
